import AMapLoader from "@amap/amap-jsapi-loader";
import { Box } from "@mui/material";
import LayerSwitch from "containers/map/layer-switch/layer-switch";
import WorldZoom from "containers/map/world-zoom/world-zoom";
import Zooms from "containers/map/zooms/zooms";
import { useEffect, useRef, useState } from "react";

const amapkey = "aee6edc014f6b2e1f310095a5c40a949";

interface AMapCandidatesProps {
  readonly center?: [number, number];
  readonly zoom?: number;
  readonly data?: any[];
  readonly selectedId?: string | null;
}

const markerColor = "#FF9900"; // for "candidates"

function AMapCandidates({
  center = [113, 30],
  zoom = 3,
  data = [],
  selectedId
}: AMapCandidatesProps) {
  const containerIdRef = useRef(
    `candidate-map-${new Date().getTime()}`
  );
  const mapRef = useRef<any>(null);
  const markerRef = useRef<any>(null);
  const AMapRef = useRef<any>(null);
  const [isMapReady, setIsMapReady] = useState(false);

  useEffect(() => {
    const isUnmounted = { current: false };
    (window as any)._AMapSecurityConfig = {
      securityJsCode: "1ff8751ba0f4086ec444b1acbb56f14a"
    };

    let map: any;
    AMapLoader.load({
      key: amapkey,
      version: "2.0",
      plugins: ["AMap.Marker", "AMap.ToolBar"]
    })
      .then((AMap) => {
        if (isUnmounted.current) {
          return;
        }
        AMapRef.current = AMap;
        map = new AMap.Map(containerIdRef.current, {
          zoom: zoom,
          center: center,
          resizeEnable: true
        });
        mapRef.current = map;

        const scale = new AMap.Scale({
          position: { bottom: "10px", right: "30px" },
        });
        map.addControl(scale);
        // const toolBar = new AMap.ToolBar();
        // map.addControl(toolBar);
        setIsMapReady(true);
      })
      .catch((e) => console.log(e));

    return () => {
      isUnmounted.current = true;
      if (mapRef.current) {
        mapRef.current.destroy();
        mapRef.current = null;
      }
      setIsMapReady(false);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Effect for creating/updating the single marker when selectedId changes
  useEffect(() => {
    if (!isMapReady || !mapRef.current || !AMapRef.current) {
      return;
    }

    const AMap = AMapRef.current;
    const map = mapRef.current;

    // 清除旧标记
    if (markerRef.current) {
      map.remove(markerRef.current);
      markerRef.current = null;
    }

    if (selectedId) {
      const selectedItem = data?.find((item) => item.id === selectedId);

      if (selectedItem && selectedItem.longitude && selectedItem.latitude) {
        const position = new AMap.LngLat(
          selectedItem.longitude,
          selectedItem.latitude
        );
        const marker = new AMap.Marker({
          position: position,
          content:
            '<img src="/icon_map_pin_yellow.svg" style="width:30px;height:42px;"></img>',
          offset: new AMap.Pixel(-15, -42)
        });

        map.add(marker);
        markerRef.current = marker;

        map.setCenter(position);
        if (map.getZoom() < 7) {
          map.setZoom(17);
        }
      }
    } else {
      // 如果没有 selectedId，重置地图视图
      map.setCenter(center);
      map.setZoom(zoom);
    }
  }, [isMapReady, selectedId, data, center, zoom]);

  return (
    <Box style={{ width: "100%", height: "100%", position: "relative" }}>
      <Box
        id={containerIdRef.current}
        style={{ width: "100%", height: "100%", borderRadius: "3px" }}
      />
      <LayerSwitch map={mapRef.current} style={{ right: "30px" }}></LayerSwitch>
      <WorldZoom map={mapRef.current} style={{ right: "30px" }}></WorldZoom>
      <Zooms map={mapRef.current} style={{ right: "30px" }}></Zooms>
    </Box>
  );
}

export default AMapCandidates;